module.exports = new Promise((resolve, reject) => {
    const name = "ui_core";
    const url = "https://microfront-qa.bprcasa.com/remoteEntry.js";
    const registry = globalThis.__HIR_REMOTE_CONTAINERS__ ||= Object.create(null);
    const existing = registry[name];
    if (existing) {
      if (existing.url !== url) return reject(new Error('Conflicting remote URL: ' + name));
      return existing.promise.then(resolve, reject);
    }
    const entry = { url, promise: null };
    registry[name] = entry;
    entry.promise = new Promise((loaded, failed) => {
      if (globalThis[name]) return loaded(globalThis[name]);
      const script = document.createElement('script');
      const source = new URL(url, document.baseURI);
      source.searchParams.set('t', String(Date.now()));
      script.src = source.href;
      const timer = setTimeout(() => finish(new Error('Remote load timed out: ' + name)), 30000);
      const finish = error => {
        clearTimeout(timer);
        script.onload = script.onerror = null;
        if (error) { script.remove(); failed(error); }
        else if (!globalThis[name]) failed(new Error('Remote container missing: ' + name));
        else loaded(globalThis[name]);
      };
      script.onload = () => finish();
      script.onerror = () => finish(new Error('Remote load failed: ' + name));
      document.head.appendChild(script);
    });
    entry.promise.catch(() => { if (registry[name] === entry) delete registry[name]; });
    entry.promise.then(resolve, reject);
  });